import { FC, useRef } from 'react';
import { Configure, Hits, InstantSearch, Pagination, SearchBox, useHits } from 'react-instantsearch';
import { useStats, type UseStatsProps } from '../../../shared/components';
import { Hit } from './components';
import { AlgoliaUtil, QueryParamsUtil } from '../../../shared/utils';
import { usePaginationScrollTop } from '../../../shared/use/pagination-scroll';
import { AlgoliaArticleHit } from '../../../shared/types';

type ArticlesSectionProps = UseStatsProps & {
  searchQuery: string;
  algoliaUtil: AlgoliaUtil;
  hideSection: () => unknown;
};

const ArticlesSectionContent: FC<{ searchQuery: string; algoliaUtil: AlgoliaUtil }> = ({
  searchQuery,
  algoliaUtil,
}) => {
  const topRef = useRef<HTMLDivElement>(null);
  const { hits } = useHits();

  usePaginationScrollTop(topRef, 60);

  return (
    <main className="sr-content" ref={topRef}>
      <header className="sr-header">
        <h1 className="title">
          {theme.locales.articlesSearch}: <span className="search-query">{searchQuery}</span>
        </h1>
      </header>

      <div className="ais-Hits">
        <ol className="ais-Hits-list">
          {hits.map((hit) => (
            <li className="ais-Hits-item" key={hit.objectID}>
              <Hit hit={algoliaUtil.normalizeArticleHit(hit as unknown as AlgoliaArticleHit)} />
            </li>
          ))}
        </ol>
      </div>

      <Pagination showFirst={false} showLast={false} />
    </main>
  );
};

export const ArticlesSection: FC<ArticlesSectionProps> = ({ searchQuery, hideSection, algoliaUtil }) => {
  const onClickBackToSearchResults = () => {
    const newURL = new URL(window.location.href);
    newURL.searchParams.set('view', 'results');

    window.history.replaceState({}, ``, newURL);
    hideSection();
  };

  return (
    <div className="sr-articles-container" style={{ minHeight: '80vh' }}>
      <div className="go-to-search-results">
        <button
          onClick={onClickBackToSearchResults}
          aria-label={theme.locales.backToProductSearch}
        >{`< ${theme.locales.backToProductSearch}`}</button>
      </div>
      <ArticlesSectionContent algoliaUtil={algoliaUtil} searchQuery={searchQuery} />
    </div>
  );
};
